module.exports = __webpack_public_path__ + "static/media/copy-sections.5ce6e5cd.png";